const StatCard = ({ label, value, icon, trend, trendUp }) => (
  <div className="rounded-xl border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 p-5">
    <div className="flex items-start justify-between">
      <div>
        <p className="text-sm text-zinc-600 dark:text-zinc-500">{label}</p>
        <p className="mt-2 text-3xl font-semibold">{value}</p>
        {trend && (
          <p className={`mt-2 text-xs ${trendUp ? 'text-emerald-400' : 'text-zinc-600 dark:text-zinc-500'}`}>
            {trendUp ? '↑' : '→'} {trend}
          </p>
        )}
      </div>
      <div className="rounded-lg bg-glow-600/20 p-3 text-xl">{icon}</div>
    </div>
  </div>
);

export default StatCard;
